
<template>
  <div class="be-signup">
    <!-- <div class="be-content"> -->
      <div class="main-content container-fluid">
        <div class="splash-container">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading">
              <img src="/static/img/logo.png" style="width: 102px;">
            </div>

            <div class="panel-body">

              <span class="splash-title xs-pb-20">Join our mailing list</span>

              <SubscribeForm class="sub"></SubscribeForm>

              <div class="clearfix"></div>

              <hr style="margin:40px 0px;" />
              <div class="row text-center">
                <div class="col-xs-12">
                  <p>Looking to unsubscribe?</p>
                  <router-link to="/newsletter-unsubscribe" class="btn btn-default">Unsubscribe</router-link>
                </div>
              </div>
            </div>

          </div>
          <!-- <div class="splash-footer">© 2016 CLEX</div> -->
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>


<script>
  import SubscribeForm from './SubscribeForm'

  export default {
      components: { SubscribeForm, }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .sub {margin:0px auto;}
</style>



// WEBPACK FOOTER //
// Subscribe.vue?d557660e